import classNames from 'classnames'
import Parser from 'html-react-parser'
import { useEffect, useRef, useState } from 'react'
import Rating from 'react-rating'
import ReactToPrint from 'react-to-print'
import { toast } from 'react-toastify'
import apis, { SERVER_URL } from '../../../../modules/apis'
import { useLessonInfo } from '../../../../modules/apis/student/lesson/review/queries'
import { axiosGet, axiosPost } from '../../../../modules/axiosHelper'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import { s_lesson_review, s_review } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { IC_STAR_OUTLINED, IC_STAR_PRIMARY, RINGLE_LOGO_W_TEXT_SM } from '../../../../modules/images'
import {
  ICON_ARROW_RIGHT_BLACK,
  ICON_INFORMATION_RED,
  ICON_PRINTER_PRIMARY,
  ICON_QUESTION_GRAY,
} from '../../../../modules/svg/svg'
import { CDN_URL, IS_PARENT, STUDY_REVIEW } from '../../../../modules/vars'
import Button from '../../../_legacy/Button'
import { useBasicPopup } from '../../../basic/popup/BasicPopup'
import Badge from '../../../common/Badge'
import EmptyPage from '../../../common/EmptyPage'
import LoadingSpinner from '../../../common/LoadingSpinner'
import NoSSR from '../../../common/NoSSR'
import TodoCheckBox from '../../../common/TodoCheckBox'
import InputWithLabel from '../../../landing-legacy/InputWithLabel'
import Iframe from '../../../review/Iframe'
import { tracker } from '../../../review/useTracking'

const ScoreInfoModal = ({ json }) => {
  return (
    <div className="mt-[16px] flex flex-col items-center">
      <div className="mb-[0px] flex">
        <div className="border-r-1 text-h5 w-[160px] border-gray-200 pb-[8px] text-center font-bold text-black">
          Ringle Score
        </div>
        <div className="text-h5 w-[160px] text-center font-bold text-black">{json?.score_type_str}</div>
      </div>
      {json?.score_descriptions.map((item, i) => {
        const score =
          item?.score_range[0] == item?.score_range[1]
            ? item?.score_range[0]
            : item?.score_range[0] + '~' + item?.score_range[1]
        return (
          <div
            key={i}
            className={classNames(
              [
                { 'border-b-1 border-gray-200': i != json?.score_descriptions.length - 1 },
                { 'bg-gray-50 text-purple-500': item?.ringle_score == json?.ringle_score },
              ],
              'flex'
            )}
          >
            <div className="text-sBody border-r-1 w-[160px] border-gray-200 py-[2px] text-center text-black">
              {item?.ringle_score}
            </div>
            <div className="text-sBody w-[160px] py-[2px] text-center text-black">{score}</div>
          </div>
        )
      })}
    </div>
  )
}

const FeedbackLegacy = (props) => {
  const { lessonId, currentUser, isTeens } = props
  const [loading, setLoading] = useState(true)
  const basicPopup = useBasicPopup()
  const [json, setJson] = useState(null)
  useEffect(() => {
    axiosGet(apis.lessons.review.feedbackNew(lessonId, isTeens)).then((res) => {
      setJson(res)
      setLoading(false)
    })
  }, [])
  const { t } = useTranslation()

  const { data: lesson } = useLessonInfo(lessonId)

  const handleClick = async (e) => {
    e.preventDefault()
    const response = await axiosGet(apis.lessons.review.lateFeedback(lesson.id))
    if (response) {
      alert(t(s_review.alertMessage))
      window.location.reload()
    }
  }

  const feedbackCompleted = lesson && lesson.feedback_completed
  const feedbackWaivered = json?.feedback_waiver ? json?.feedback_waiver.confirmed : false

  const getFeedbackStatus = (feedback) => {
    if (lesson?.status?.err) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <p className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            {t(s_review.noshow)}
          </p>
        </div>
      )
    } else if (feedback.is_completed) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            <NoSSR>{Parser(feedback.comment)}</NoSSR>
          </div>
        </div>
      )
    } else if (feedback.is_feedback_waiver) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical modal-title overflow-hidden text-black">
            {t(s_review.feedback_waiver)}
          </div>
        </div>
      )
    } else if (!feedback.provide_feedback) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            <NoSSR>{Parser(feedback.comment)}</NoSSR>
          </div>
        </div>
      )
    } else if (feedback.request_feedback) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            {t(s_review.alertMessage)}
          </div>
        </div>
      )
    } else if (feedback.is_late) {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            <NoSSR>{Parser(feedback.comment)}</NoSSR>
          </div>
          <div className="mx-auto mt-[12px] w-full">
            <Button sm primary mt3 onClick={handleClick}>
              {t(s_review.contact)}
            </Button>
          </div>
        </div>
      )
    } else {
      return (
        <div className="mt-[32px] flex flex-col justify-center">
          <img src={ICON_INFORMATION_RED} className="mx-auto mb-[16px] h-[20px] w-[20px]" />
          <div className="box-orient-vertical line-clamp2 d-box modal-title overflow-hidden text-black">
            <NoSSR>{Parser(feedback.comment)}</NoSSR>
          </div>
        </div>
      )
    }
  }
  const commentRef = useRef(null)

  const feedbackStudy = lesson?.review_study?.list.find((item, i) => item.type == STUDY_REVIEW.FEEDBACK) || null
  const [feedbackCheck, setFeedbackCheck] = useState(feedbackStudy?.value || false)
  useEffect(() => {
    setFeedbackCheck(lesson?.review_study?.list.find((item, i) => item.type == STUDY_REVIEW.FEEDBACK)?.value)
  }, [lesson])

  // 피드백 리포트 확인완료
  const onClickStudy = (e) => {
    e.preventDefault()
    if (feedbackCheck) return
    if (rate == 0) {
      alert('Please rate the feedback')
      return
    }
    if (lesson) {
      const body = {
        score: rate,
        comment: commentRef?.current?.value,
      }
      axiosPost(apis.lessons.review.eval(lesson.id), body).then((res) => {
        if (res.success) {
          setFeedbackCheck(true)
          toast(t(s_lesson_review.completeFeedback))
        } else {
          alert('fail')
        }
      })
    }
  }
  const onClickTeensFeedback = async (e) => {
    e.preventDefault()
    if (feedbackCheck) return

    if (lesson) {
      const payload = {
        action_type: STUDY_REVIEW.FEEDBACK,
      }
      const response = await axiosPost(apis.lessons.review.study(lesson.id), payload)
      if (response) {
        setFeedbackCheck(true)
        toast(t(s_lesson_review.completeFeedback))
      }
    }
  }

  useEffect(() => {
    tracker('feedback')
    return () => tracker('feedback', true)
  }, [])
  const [rate, setRate] = useState(0)
  const onChangeRate = (i) => {
    setRate(i)
  }
  const info = [
    { key: 'Title', val: json?.lesson_info?.course_title },
    { key: 'Date', val: json?.lesson_info?.formatted_start_time },
    { key: 'Tutor', val: json?.lesson_info?.tutor_name },
    { key: 'Student', val: json?.lesson_info?.student_name },
  ]
  const categories = []
  let categories_text = ''
  json?.feedanswers?.forEach((feedanswer) => {
    if (feedanswer?.title && !categories.includes(feedanswer?.title)) {
      if (categories_text != '') {
        categories_text += ' and '
      }
      categories.push(feedanswer.title)
      categories_text += `<span class="text-decoration-underline">${feedanswer.title}</span>`
    }
  })

  const handleScoreClick = (e, i) => {
    e.preventDefault()
    basicPopup.show({
      id: 'info-popup',
      overlayClose: true,
      title: (
        <div>
          {json?.score_conversions[i].score_type_str}
          <br />
          <div className="mt-[16px] text-[14px] font-normal text-gray-500">Expected Score</div>
          <div className="text-[20px] font-bold text-purple-500">{json?.score_conversions[i].converted_score}</div>
        </div>
      ),
      body: <ScoreInfoModal json={json?.score_conversions[i]} />,
    })
  }

  const handleCategoryClick = (e, i) => {
    e.preventDefault()
    basicPopup.show({
      id: 'info-popup',
      title: json?.evaluation_result[i]?.evaluation[0]?.title,
      overlayClose: true,
      bodyPx: 0,
      body: (
        <div>
          <div className="px-[32px]">
            <div className="mb-[12px] flex items-end">
              <div className="text-h2 font-bold text-purple-500">
                {json?.evaluation_result[i]?.evaluation[0]?.score}
              </div>
              <div className="mb-[0px] ml-[2px] text-[12px] text-gray-500">/10</div>
            </div>
            <ProgressBar percent={json?.evaluation_result[i]?.evaluation[0]?.score * 10} />
            <div className="text-sBody mt-[24px] mb-[12px] text-gray-500">{t(s_lesson_review.score_criteria)}</div>
          </div>
          {json?.evaluation_result[i]?.categories[0]?.scores?.map((item) => (
            <div
              key={item.score}
              className={classNames(
                { 'bg-gray-100': item.score == json?.evaluation_result[i]?.evaluation[0]?.score },
                'px-[32px] pt-[8px] pb-[12px]'
              )}
            >
              <div className="text-h5 mb-[0px] font-bold">Score {item.score}</div>
              <div className="text-sBody text-[12px]">{item.description}</div>
            </div>
          ))}
        </div>
      ),
    })
  }
  const reportRef = useRef(null)
  const parseHtml = (str) => {
    return (
      str
        ?.replace(/background-color: rgb\(249, 251, 253\);/g, '')
        .replace(/<p><br><\/p>/g, '')
        .replace(/<p/g, "<p class='mb-0'") || ''
    )
  }

  const ProgressBar = ({ percent, h = 12, w = 268 }) => {
    return (
      <div style={{ width: w, height: h }} className="w-full rounded-[6px] bg-gray-100">
        <div style={{ width: `${percent}%` }} className="h-[12px] w-full rounded-[6px] bg-purple-500"></div>
      </div>
    )
  }

  const ProgressBox = ({ title, score, onClick }) => {
    return (
      <div
        onClick={onClick}
        className="border-1 flex w-full cursor-pointer justify-center rounded-[6px] border-gray-100 p-[16px] shadow-sm lg:ml-[20px]"
      >
        <div className=" flex w-full items-center justify-center">
          <div className="flex items-end">
            <div className="w-full ">
              <div className="mb-[11px] flex w-full">
                <div className="text-h5 text-[14px] text-black">{title}</div>
                <div className="text-h5 ml-auto text-[12px]">
                  <span className="text-purple-500">{score}</span>
                  <span className="text-gray-500">/10</span>
                </div>
              </div>
              <ProgressBar percent={score * 10} />
            </div>
            <span className="fe fe-chevron-right mt-[5px] ml-[8px] w-full items-end text-gray-500"></span>
          </div>
        </div>
      </div>
    )
  }
  const ScoreBox = ({ title, score, onClick }) => {
    return (
      <div
        onClick={onClick}
        className="text-sBody flex h-[54px] w-full cursor-pointer items-center bg-gray-50 px-[16px]"
      >
        <div className="mr-[4px] text-black">{title}</div>
        <img src={ICON_QUESTION_GRAY} />
        <div className="ml-auto mb-[0px] text-black">{score}</div>
      </div>
    )
  }
  const RatingSection = () => {
    return (
      <div className="flex w-full justify-center">
        {!feedbackCheck ? (
          <div className="flex w-full flex-col items-center">
            <div className="text-h2 mb-[17px] font-bold text-black">{t(s_lesson_review.please_evaluate_feedback)}</div>
            <Rating
              className="mb-18"
              initialRating={rate}
              onChange={(rate) => onChangeRate(rate)}
              emptySymbol={<img className="mr-4 max-w-none" src={IC_STAR_OUTLINED} />}
              fullSymbol={<img className="mr-4 max-w-none" src={IC_STAR_PRIMARY} />}
              stop={5}
            />
            <InputWithLabel
              clx="w-full"
              ref={commentRef}
              textarea
              placeholder={t(s_lesson_review.please_write_reason)}
            />
          </div>
        ) : (
          <div className="mb-[4px] text-[20px] font-bold text-black">That's all for this lesson! Happy Ringling!</div>
        )}
      </div>
    )
  }
  const FeedbackContent = () => {
    const isMobile = useIsMobile()
    return (
      <div className="w-full">
        {/* <div className="mb-[32px] h-[1px] w-full" /> */}
        <div className="text-h2 mb-[8px] font-bold text-black">Overall Feedback</div>
        <div
          dangerouslySetInnerHTML={{
            __html: parseHtml(json?.overall_comment),
          }}
          className="text-sBody"
        />
        {!isMobile && <div className="h-[32px]" />}
        <div className="text-h2 mt-[32px] font-bold text-black">Average Score</div>
        <div className="mt-[16px] flex w-full flex-col sm:mx-auto">
          <div style={{ display: 'grid' }} className="flex-col content-center">
            <div className="flex w-full items-center justify-center">
              <span className="text-d1 mr-[2px] font-bold text-black">{json?.avg_score}</span>
              <span className="text-h2 font-20px mt-[20px] h-[28px] w-[31px] font-bold text-gray-500">/10</span>
            </div>
          </div>
          <div className="review flex w-full flex-col lg:ml-auto">
            <div className="mx-auto mb-[12px] flex w-full flex-col gap-y-[12px] sm:flex-row sm:gap-x-[12px]">
              <ProgressBox
                title={json?.evaluation_result[0]?.evaluation[0]?.title}
                score={json?.evaluation_result[0]?.evaluation[0]?.score}
                onClick={(e) => handleCategoryClick(e, 0)}
              />
              <ProgressBox
                title={json?.evaluation_result[1]?.evaluation[0]?.title}
                score={json?.evaluation_result[1]?.evaluation[0]?.score}
                onClick={(e) => handleCategoryClick(e, 1)}
              />
            </div>
            <div className="mx-auto mb-[12px] flex w-full flex-col gap-y-[12px] sm:flex-row sm:gap-x-[12px]">
              <ProgressBox
                title={json?.evaluation_result[2]?.evaluation[0]?.title}
                score={json?.evaluation_result[2]?.evaluation[0]?.score}
                onClick={(e) => handleCategoryClick(e, 2)}
              />
              <ProgressBox
                title={json?.evaluation_result[3]?.evaluation[0]?.title}
                score={json?.evaluation_result[3]?.evaluation[0]?.score}
                onClick={(e) => handleCategoryClick(e, 3)}
              />
            </div>
          </div>
        </div>
        <div className="mt-[32px] w-full">
          <div className="text-h2 mb-[16px] w-full font-bold text-black">Estimated Score</div>
          <div className="justify-auto flex w-full flex-col gap-y-[12px] lg:flex-row lg:justify-between">
            <ScoreBox
              title={json?.score_conversions[0]?.score_type_str}
              score={json?.score_conversions[0]?.converted_score}
              onClick={(e) => handleScoreClick(e, 0)}
            />
            <ScoreBox
              title={json?.score_conversions[1]?.score_type_str}
              score={json?.score_conversions[1]?.converted_score}
              onClick={(e) => handleScoreClick(e, 1)}
            />
            <ScoreBox
              title={json?.score_conversions[2]?.score_type_str}
              score={json?.score_conversions[2]?.converted_score}
              onClick={(e) => handleScoreClick(e, 2)}
            />
          </div>
        </div>
        <div className="mt-[47px]">
          <div className="text-h2 mb-[4px] font-bold text-black">In-depth Feedback</div>
          <div className="text-sBody mb-[16px] text-gray-500">
            In accordance with your lesson's focus, the tutor has chosen to offer feedback on{' '}
            <span dangerouslySetInnerHTML={{ __html: categories_text }} />.
          </div>
          {json?.feedanswers?.map((feedanswer, i) => (
            <div key={i} className="mb-[16px]">
              <div className="text-h4 mb-[8px] font-medium text-black"># {feedanswer.title}</div>
              {feedanswer.answer.map((answer, j) => (
                <div key={`key-${i}-${j}`}>
                  {parseHtml(answer?.wrong_content) && answer?.wrong_content != 'ringle' && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: parseHtml(answer?.wrong_content),
                      }}
                      className="text-h5 mb-[16px] text-red-500"
                    />
                  )}
                  {parseHtml(answer?.right_content) && answer?.right_content != 'ringle' && (
                    <div className="mb-[16px] flex">
                      <span className="fe fe-arrow-right mr-[4px]"></span>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: parseHtml(answer?.right_content),
                        }}
                        className="text-h5 text-black"
                      />
                    </div>
                  )}
                  {parseHtml(answer?.content) && (
                    <div
                      className={classNames(
                        'mb-[16px] bg-yellow-50 p-[16px]',
                        i + 1 < json?.feedanswers.length && 'mb-4'
                      )}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: parseHtml(answer?.content),
                        }}
                        className="text-h5"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }

  const TeensFeedbackContent = () => {
    const parentMsg = json?.answers?.find((item, i) => item.parent_only == true)?.body[0]
    const mainMsg = json?.answers?.filter((item, i) => item.parent_only == false && item.type == 'text')
    const categoryMsg = json?.answers?.filter((item, i) => item.parent_only == false && item.type == 'category')
    const keywordMsg = json?.answers?.filter((item, i) => item.parent_only == false && item.type == 'keyword')
    const concentrationMsg = json?.answers?.filter((item, i) => item.title == 'For Parents')[0]?.body[0]?.attitude

    const { currentUser } = useCurrentUser()

    const parseContent = (content = '') => {
      return Parser(content || '')
    }
    const studentName = json?.lesson_info?.student_name

    const getConcentration = (content) => {
      switch (content) {
        case 0:
          return (
            <div>
              {studentName} was
              <div className={classNames('ml-[4px] font-medium text-blue-500')}>Deeply Focused</div>, engaging
              extensively during the lesson.
            </div>
          )
        case 1:
          return (
            <div>
              {studentName} was
              <div className={classNames('ml-[4px] font-medium text-blue-500')}>Focusing on the topic</div>, able to
              focus on the lesson, and stayed on topic.
            </div>
          )
        case 2:
          return (
            <div>
              {studentName} was <div className={classNames('ml-[4px] font-medium text-blue-500')}>Distracted</div>,
              unable to concentrate during the class, the conversation couldn’t stay on topic.
            </div>
          )
        case 3:
          return (
            <div>
              {studentName} was <div className="ml-[4px] font-medium text-blue-500">Very distracted</div>, unable to
              stay on the seat, running around and actively moving.
            </div>
          )
      }
    }
    const getCategory = (content) => {
      switch (content) {
        case 'Critical Thinking Skills':
          return (
            <Badge bgPrimaryLight textPrimary>
              {content}
            </Badge>
          )
        case 'Creative Thinking Skills':
          return (
            <Badge bgInfoLight textInfo>
              {content}
            </Badge>
          )
        case 'Communication Skills':
          return (
            <Badge bgSuccessLight textSuccess>
              {content}
            </Badge>
          )
      }
    }
    return (
      <div>
        {(IS_PARENT(currentUser) || isTeens) && (
          <div>
            <div>
              <div className="text-h2 mb-[16px] font-bold text-black">Messages to Parent</div>
              <div className="text-h5 flex flex-col rounded-[5px] border-gray-100 bg-gray-50 p-[16px]">
                <div className="mb-[12px] flex flex-row">
                  <div className="mr-[4px] text-[16px]">•</div>
                  {getConcentration(concentrationMsg)}
                </div>
                <div className="flex flex-row">
                  <span className="mr-[4px] text-[16px]">•</span>
                  <span className="flex-col">{parseContent(parentMsg?.content)}</span>
                </div>
              </div>
            </div>
            <div className="my-[24px] h-[1px] w-full bg-gray-200"></div>
          </div>
        )}
        {mainMsg?.length > 0 &&
          mainMsg?.map((answer, i) => (
            <div key={`student_msg_${i}`}>
              <div className="text-h2 mb-[16px] font-bold text-black">{answer.title}</div>
              <div className="text-h5 h5">{parseContent(answer.body[0].content)}</div>
              <div
                className={classNames(
                  i + 1 == json?.feedanswers?.length > 0 && 'hidden',
                  'my-[24px] h-[1px] w-full bg-gray-200'
                )}
              ></div>
            </div>
          ))}
        {categoryMsg?.map((item, i) => (
          <div key={`category_${i}`}>
            <div className="text-h2 mb-[16px] font-bold text-black">{item.title}</div>
            {item.body.map((obj, j) => (
              <div key={`key-${i}-${j}`} className="mb-[16px] flex flex-col">
                <div className="text-h5 mb-[4px] font-bold">
                  {obj.keyword} <span className="ml-[8px] font-medium">{getCategory(obj.category)}</span>
                </div>
                <div className="text-[14px]">{parseContent(obj.content)}</div>
              </div>
            ))}
            <div
              className={classNames(
                i + 1 == json?.feedanswers?.length > 0 && 'hidden',
                'my-[24px] h-[1px] w-full bg-gray-200'
              )}
            ></div>
          </div>
        ))}
        {keywordMsg?.map((item, i) => (
          <div key={`keyword_${i}`}>
            <ul className="text-h2 mb-[16px] font-bold text-black">{item.title}</ul>
            {item.body.map((obj, j) => {
              return obj.category ? (
                <li key={`key-${i}-${j}`} className="mb-[4px]">
                  <span className={classNames('text-h5 font-bold text-blue-500')}>{obj.category}</span>
                  <div className="ordered-list pl-[24px] text-[14px]">{parseContent(obj.content)}</div>
                </li>
              ) : (
                <div key={`key-${i}-${j}`} className="mb-[4px]">
                  <span className={classNames('text-h5 font-bold text-blue-500')}>{obj.category}</span>
                  <div className="ordered-list pl-[24px] text-[14px]">{parseContent(obj.content)}</div>
                </div>
              )
            })}
          </div>
        ))}
      </div>
    )
  }

  return (
    <div className="w-full">
      {loading ? (
        <LoadingSpinner show primary />
      ) : (
        <div className="w-full pt-[38px] sm:mx-auto lg:max-w-[1000px]">
          {isTeens ? (
            <div ref={reportRef} className="px-[32px] py-[24px]">
              <div className="flex justify-between">
                <div className="flex flex-col">
                  <div>
                    <div className="mb-[4px] flex items-center">
                      <img src={`${CDN_URL}/new-theme/teens/logo_w_text.svg`} />
                    </div>
                    <div className="text-gray-500">Feedback Report</div>
                  </div>
                  {/* Heading Section */}
                  <div style={{ marginLeft: 110, maxWidth: 330 }} className="max-w-[330px] lg:ml-[122px]">
                    {info.map((item, i) => (
                      <div key={i} className="flex">
                        <div style={{ width: 85 }} className="text-h5 mb-[4px] w-[85px] font-medium text-black">
                          {item.key}
                        </div>
                        <div className="text-sBody h5 text-black">{item.val}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="no-print ml-auto">
                  <ReactToPrint
                    pageStyle="p-32"
                    trigger={() => (
                      <Button
                        sm
                        textInfo
                        borderInfo
                        outlined
                        flex
                        itemsCenter
                        icon={`${CDN_URL}/new-theme/new-icons/teens/icon/printer/primary.svg`}
                      >
                        <div>Print</div>
                      </Button>
                    )}
                    content={() => reportRef.current}
                  />
                </div>
              </div>
              <div className="mt-[20px] mb-[32px] h-[1px] w-full bg-gray-200"></div>
              <TeensFeedbackContent />
            </div>
          ) : feedbackCompleted && !feedbackWaivered ? (
            <div>
              {lesson.after_renewal ? (
                <div className="w-full">
                  <div ref={reportRef} className="w-full px-[16px] py-[5px] sm:px-[32px]">
                    <div className="flex w-full justify-between">
                      <div className="flex w-full flex-col gap-y-[24px] sm:flex-row">
                        <div className="max-w-[131px] sm:mr-[121px]">
                          <div className="mb-[4px] flex h-[30px] w-[131px] items-center">
                            <img src={RINGLE_LOGO_W_TEXT_SM} />
                          </div>
                          <div className="text-gray-500">Feedback Report</div>
                        </div>
                        {/* Heading Section */}
                        <div className=" w-full max-w-[575px] break-all sm:max-w-[330px] lg:ml-[110px] lg:mr-[15px]">
                          {info.map((item, i) => (
                            <div key={i} className="flex w-full">
                              <div className="text-h5 w-[85px] font-medium text-black">{item.key}</div>
                              <div className="text-sBody text-black">{item.val}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="no-print hidden lg:block">
                        <ReactToPrint
                          pageStyle="p-32"
                          trigger={() => (
                            <Button sm w110 outlined>
                              <div className="flex flex-row items-center">
                                <img
                                  src={ICON_PRINTER_PRIMARY}
                                  style={{ width: 14, height: 14 }}
                                  className="max-w-none"
                                />
                                <div className="ml-[8px]">Print</div>
                              </div>
                            </Button>
                          )}
                          content={() => reportRef.current}
                        />
                      </div>
                    </div>
                    <div className="my-[32px] h-[1px] w-full bg-gray-200"></div>
                    <FeedbackContent />
                    {/* 80자 첨삭 */}
                    {json?.requested_texts?.length > 0 && (
                      <div>
                        <div className="mt-[6px]">
                          <div className="text-h2 mb-[2px] text-[20px] font-bold text-black">
                            Feedback on Submitted Content
                          </div>
                          {json?.requested_texts.map((request, i) => (
                            <div key={i}>
                              <div className="text-h4 mb-[4px] font-bold text-black">Submitted Content</div>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: parseHtml(request?.content),
                                }}
                                className="text-h5 mb-[8px] text-black"
                              ></div>
                              <div className="text-h4 mb-[4px] font-bold text-black">Correction</div>
                              <div className="flex">
                                <img src={ICON_ARROW_RIGHT_BLACK} />
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: parseHtml(request?.rvt_correction?.content),
                                  }}
                                  className="text-h4 mb-[8px] text-black"
                                ></div>
                              </div>
                              <div className="text-h4 mb-[4px] font-bold text-black">Paraphrase</div>
                              <div
                                className={classNames(
                                  [
                                    {
                                      'mb-4': i + 1 < json?.requested_texts?.length,
                                    },
                                  ],
                                  'p-[2px] text-black'
                                )}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: parseHtml(request?.rvt_paraphrase?.content),
                                  }}
                                  className="text-h5 mb-[0px]"
                                ></div>
                              </div>
                            </div>
                          ))}
                        </div>
                        <div className="border-t-1 mt-[32px] mb-[47px] h-[1px] w-full border-gray-200" />
                      </div>
                    )}
                  </div>

                  {/* 피드백 보고서 평가 */}
                  <div className="mt-[6px] flex w-full flex-col items-center justify-center px-[16px] py-[5px] sm:px-[32px]">
                    <RatingSection />
                    <TodoCheckBox
                      clx="mt-32"
                      onClick={onClickStudy}
                      checked={feedbackCheck}
                      title={t(s_lesson_review.completeFeedbackButton)}
                    />
                  </div>
                </div>
              ) : (
                <div style={{ height: '100vh' }}>
                  <Iframe
                    source={
                      lesson.new_feedback
                        ? `${SERVER_URL}/reports/feedback_new/${lesson.id}?123`
                        : `${SERVER_URL}/reports/feedback/${lesson.id}`
                    }
                  />
                </div>
              )}
            </div>
          ) : (
            <EmptyPage
              title={
                lesson && lesson.course.provide_feedback
                  ? getFeedbackStatus(lesson.feedback)
                  : t(s_lesson_review.not_provide_feedback)
              }
            />
          )}
          <div className="h-[200px]" />
        </div>
      )}
    </div>
  )
}

export default FeedbackLegacy
